/**
 * Sort locals: Central first, then alphabetical by name.
 * Works with any object that has `isCentral` and a name field (nameLounge, localName, name, nombre, loungeName).
 */
export const sortLocalsCentralFirst = <T extends Record<string, any>>(locals: T[]): T[] => {
  if (!Array.isArray(locals)) return locals;
  return [...locals].sort((a, b) => {
    const aCentral = Number(a.isCentral) === 1 || a.isCentral === true;
    const bCentral = Number(b.isCentral) === 1 || b.isCentral === true;
    if (aCentral && !bCentral) return -1;
    if (!aCentral && bCentral) return 1;
    const aName = (a.nameLounge || a.localName || a.name || a.nombre || a.loungeName || "").toLowerCase();
    const bName = (b.nameLounge || b.localName || b.name || b.nombre || b.loungeName || "").toLowerCase();
    return aName.localeCompare(bName);
  });
};
